import React, {useEffect, useState} from 'react';
import { observer } from 'mobx-react';


// Dependencies
import moment from 'moment';
import DatePicker from 'react-datepicker';

// Components
import * as icons from '../Icons/Icons';
import {Radio, RadioGroup} from "react-radio-group";
import translate from "../Translate";

const Availability = (props) => {

  const [isValidated, setIsValidated] = useState(true);
  const [createArray, setCreateArray] = useState([]);
  const [updateArray, setUpdateArray] = useState ([]);
  const [deleteArray, setDeleteArray] = useState ([]);
  const [removeOverrideObject, setRemoveOverrideObject] = useState(null);
  const [customize, setCustomize] = useState(false);
  const [inputObject, setInputObject] = useState(null);
  const [daysOfWeekObject, setDaysOfWeekObject] = useState({
    0: [],
    1: [],
    2: [],
    3: [],
    4: [],
    5: [],
    6: []
  });

  const translation = props.translation;
  useEffect(() => {
    if(props.cleanedAvailabilities && props.calendar) {
      if(props.cleanedAvailabilities.length > 0) {
        setCustomize(props.cleanedAvailabilities[0].override);
      } else {
        setCustomize(false)
      }
      setDaysOfWeekObject({ [props.dayOfWeek]: [...props.cleanedAvailabilities]})
    }
    else if(!props.calendar) {
      // eslint-disable-next-line
      getDefaultDates()
    }

  } ,[props.cleanedAvailabilities])

  const removeAvailability = () => {
    const { ScheduleStore } = props.store;
    const { schedule } = ScheduleStore.locationCalendar;

    let deleteArray = []
    const dateToSearch = moment(props.startDate).format('YYYY-MM-DD');
    const availabilities = ScheduleStore.availabilities[dateToSearch];
    const noAvailability = availabilities.filter(obj => {
      return obj.excludeDate;
    });

    for(const availability of daysOfWeekObject[props.dayOfWeek]) {
      if (availability.sid.indexOf('temp') === -1) {
        deleteArray.push({sid: availability.sid})
      }
    }
    deleteArray = [...deleteArray, ...noAvailability];
    let data = {
      create: [],
      update: [],
      delete: deleteArray
    }
    const callback = () => {
      props.callback();
      props.closeView();
    }
    ScheduleStore.updateAvailability(schedule.sid, data, callback);
  }

  useEffect(() => {
    if(inputObject){
      //eslint-disable-next-line
      handleInput(inputObject.sid, inputObject.day);
      setInputObject(null);
    }
  },[inputObject])

  const customizeAvailability = () => {

    let create = [...createArray]
    let availabilities = props.cleanedAvailabilities;

    for(const availability of availabilities){
      availability.startDate = props.startDate;
      availability.endDate = props.endDate
      availability.sid = `temp-${(new Date()).getTime()}${Math.random()}`


      delete availability.createdDate;
      delete availability.editDate;
      delete availability.name;
      delete availability.override;
      delete availability.recurring;
      delete availability.scheduleSid;

      create.push(availability);
    }


    // Remove temporary sids from the create array
    setDaysOfWeekObject({ [props.dayOfWeek]: [...availabilities]})
    setCreateArray(create);
    setCustomize(true);

  }

    const parseAvailabilities = (data, daysOfWeek) => {
      data.forEach(availability => {
        availability.startTime = `${availability.startTime.split(':')[0]}:${availability.startTime.split(':')[1]}`;
        availability.endTime = `${availability.endTime.split(':')[0]}:${availability.endTime.split(':')[1]}`;

        daysOfWeek[availability.dayOfWeek].push(availability);

        if(!props.calendar) {
          // Remove overrides if we’re editing the default
          for(let i = 0; i < daysOfWeek[availability.dayOfWeek].length; i++) {
            if(daysOfWeek[availability.dayOfWeek][i].override) {
              daysOfWeek[availability.dayOfWeek].splice(i, 1);
            }
          }
        }
      })
      setDaysOfWeekObject(() => {
        const newArr = {...daysOfWeek};
        return newArr;
      })
    };

  const copyHours = (row, dayOfWeek) => {
    const daysOfWeek = {...daysOfWeekObject};
    const create =  createArray;

    Object.keys(daysOfWeek).forEach((day) => {
      if(daysOfWeek[day].length === 0) {
        // Make a copy of the provided row
        // and apply it to each empty day
        for(let i = 0; i < row.length; i++) {
          daysOfWeek[day][i] = {...row[i]};
          daysOfWeek[day][i].sid = `temp-${(new Date()).getTime()}${i}${day}`;
          daysOfWeek[day][i].startDate = row[i].startDate;
          daysOfWeek[day][i].endDate = row[i].endDate;
          daysOfWeek[day][i].dayOfWeek = day;

          // Delete unnecessary data
          delete daysOfWeek[day][i].createdDate;
          delete daysOfWeek[day][i].editDate;
          delete daysOfWeek[day][i].name;
          delete daysOfWeek[day][i].override;
          delete daysOfWeek[day][i].recurring;
          delete daysOfWeek[day][i].scheduleSid;

          // Push these new records to create
          create.push(daysOfWeek[day][i]);
        }
      }
    });

    setDaysOfWeekObject(daysOfWeek);
    setCreateArray(create);
  }
  const getDefaultDates = () => {
    const { ScheduleStore } = props.store;
    const { schedule } = ScheduleStore.locationCalendar;

    const callback = (data) => {
      parseAvailabilities(data, daysOfWeekObject);
    };
    ScheduleStore.getScheduleAvailability(schedule.sid, callback);
  };

  const handleInput = (sid, dayOfWeek) => {
    // Make copies of state data
    const daysOfWeek = {...daysOfWeekObject};
    let create = createArray
    let update = updateArray

    if(sid.indexOf('temp') > -1) {
      // Find the correct object from the create array
      const createRowObj = daysOfWeek[dayOfWeek].filter(obj => {
        return obj.sid === sid;
      })[0];

      create = create.filter(obj => {
        return obj.sid !== sid;
      });

      // Update the start and end time
      create.push(createRowObj);
    } else {
      const updateRowObj = daysOfWeek[dayOfWeek].filter(obj => {
        return obj.sid === sid;
      })[0];

      // Delete properties we don't need
      delete updateRowObj.createdDate;
      delete updateRowObj.editDate;
      delete updateRowObj.pilname;
      delete updateRowObj.scheduleSid;
      delete updateRowObj.recurring;

      if(!props.calendar || updateRowObj.override) {
        update.push(updateRowObj);
      } else {
        updateRowObj.sid = `temp-${(new Date()).getTime()}`;
        updateRowObj.startDate = moment(props.startDate).format('YYYY-MM-DD');
        updateRowObj.endDate = moment(props.endDate).format('YYYY-MM-DD');
        delete updateRowObj.override;
        update.push(updateRowObj);
      }
    }

    setDaysOfWeekObject(daysOfWeek)
    setCreateArray(create);
    setUpdateArray(update);
  }

  const updateValidationText = (availabilitySid, text = null) => {
    const validationId = `${availabilitySid}-validation`;
    const validationItem = document.getElementById(validationId);
    validationItem.innerHTML = !text ?
        '' :
        text;
  }

  const isDateBetween = (checkDate, startDate, endDate, inclusive = false) => {
    if(inclusive){
      return (checkDate >= startDate && checkDate <= endDate);
    } else {
      return (checkDate > startDate && checkDate < endDate);
    }
  }

  const validateTimeInputs = (day) => {
    let isValid = true;
    const availabilityForDay = daysOfWeekObject[day];

    for (const [index, availability] of availabilityForDay.entries()) {
      if (availability.startTime && availability.endTime) {
        const startTime = availability.startTime.split(':');
        const endTime = availability.endTime.split(':');
        const start = new Date(availability.startDate);
        if (typeof availability.startDate === 'string' || availability.startDate instanceof String) {
          start.setDate(start.getDate() + 1);
        }
        start.setHours(startTime[0], startTime[1]);
        const end = new Date(availability.endDate);
        if (typeof availability.endDate === 'string' || availability.endDate instanceof String) {
          end.setDate(end.getDate() + 1);
        }
        end.setHours(endTime[0], endTime[1]);
        // Creating "normalized" times here so that we can compare just the actual times for a day. Otherwise we are
        // comparing the date times for overlaps, and those are not restricted to a single day
        // By using epoch, it will start at time zero, so it will just be the time of day
        const epoch = '1970-01-01T';
        const normalizedStartTime = new Date(epoch + startTime[0] + ':' + startTime[1] + ':00');
        const normalizedEndTime = new Date(epoch + endTime[0] + ':' + endTime[1] + ':00');
        // Check start time is before end time
        if (start >= end || normalizedStartTime >= normalizedEndTime) {
          isValid = false;
          updateValidationText(availability.sid, translation.end_before_start_time);
        } else {
          updateValidationText(availability.sid);
        }
        // Make sure the availability does not overlap with any previous availabilities
        for (let i = 0; i < index; i++) {
          const previousAvailability = availabilityForDay[i];

          const previousStartTime = previousAvailability.startTime.split(':');
          const previousStart = new Date(previousAvailability.startDate);
          if (typeof previousAvailability.startDate === 'string' || previousAvailability.startDate instanceof String) {
            previousStart.setDate(previousStart.getDate() + 1);
          }
          previousStart.setHours(previousStartTime[0], previousStartTime[1]);

          const previousEndTime = previousAvailability.endTime.split(':');
          const previousEnd = new Date(previousAvailability.endDate);
          if (typeof previousAvailability.endDate === 'string' || previousAvailability.endDate instanceof String) {
            previousEnd.setDate(previousEnd.getDate() + 1);
          }
          previousEnd.setHours(previousEndTime[0], previousEndTime[1]);

          // Check if start time is between previous start and end
          // Check if end time is between previous start and end
          // Check if previous start time is between new start and end
          // Check if previous end time is between new start and end
          if (isDateBetween(start, previousStart, previousEnd) ||
              isDateBetween(end, previousStart, previousEnd) ||
              isDateBetween(previousStart, start, end) ||
              isDateBetween(previousEnd, start, end)
          ) {
            // Availability is already set on this day, lets see if the times overlap now
            // We will follow the same process as above, but we will set the date to always be the date of the epoch
            // so we will then always be comparing based off time only
            const normalizedPrevStartTime = new Date(epoch + previousStartTime[0] + ':' + previousStartTime[1] + ':00');
            const normalizedPrevEndTime = new Date(epoch + previousEndTime[0] + ':' + previousEndTime[1] + ':00');
            if (isDateBetween(normalizedStartTime, normalizedPrevStartTime, normalizedPrevEndTime) ||
                isDateBetween(normalizedEndTime, normalizedPrevStartTime, normalizedPrevEndTime) ||
                isDateBetween(normalizedPrevStartTime, normalizedStartTime, normalizedEndTime) ||
                isDateBetween(normalizedPrevEndTime, normalizedStartTime, normalizedEndTime)
            ) {
              isValid = false;
              updateValidationText(availability.sid, translation.times_overlap);
            }
          }
        }
      } else {
        isValid = false;
        updateValidationText(availability.sid, translation.required)
      }
    }
    setIsValidated(isValid);
  }

  const addRow = (day, i) => {
    setRemoveOverrideObject(null);
    const daysOfWeek = {...daysOfWeekObject};
    const create = [...createArray];

    let startDate = moment();
    let endDate = moment().add(1, 'day');

    if(props.startDate) {
      startDate = moment(props.startDate).format('YYYY-MM-DD');
    }

    if(props.endDate) {
      endDate = moment(props.endDate).format('YYYY-MM-DD');
    }

    const row = {
      sid: `temp-${(new Date()).getTime()}`,
      dayOfWeek: i || day,
      startTime: null,
      endTime: null,
      startDate: startDate,
      endDate: endDate,
      numberOfSeats: null
    }

    daysOfWeek[day].push(row);
    create.push(row);

    setDaysOfWeekObject(daysOfWeek);
    setCreateArray(create);

    // Do not allow saving until the fields have been updated
    setTimeout(() => {
      validateTimeInputs(day);
    }, 100);
  }

  const deleteRow = (dayOfWeek, i, sid, override, row, isCalendar) => {
    const daysOfWeek = {...daysOfWeekObject};
    const createArr = [...createArray];
    const deleteArr = [...deleteArray];

    // Remove the row from the day of week in state
    daysOfWeek[dayOfWeek].splice(i, 1);

    // Add the sid to the delete array if it isn't new
    if(!props.calendar) {
      if(sid.indexOf('temp') < 0) {
        // If it’s not temporary, delete it
        deleteArr.push({sid: sid});
      }
    } else if(props.calendar && override) {
      deleteArr.push({sid: sid});
    }
    // If it’s a new row, remove it from the create array
    if(sid.indexOf('temp') >= 0) {
      for(let j = 0; j < createArr.length; j++) {
        if(createArr[j].sid === sid) {
          createArr.splice(j, 1);
        }
      }
    }
    // If we remove the last availability for the day, we need to add an "availability" to remove availabilities
    if (isCalendar && daysOfWeek[dayOfWeek].length === 0) {
      setRemoveOverrideObject(row);
    }

    setDaysOfWeekObject(daysOfWeek);
    setDeleteArray(deleteArr);
    setCreateArray(createArr);

    // allow state to update before validating
    setTimeout(() => {
      validateTimeInputs(dayOfWeek);
    }, 100);
  }
  const handleStartDate = (date, day, i) => {
    let copy = {...daysOfWeekObject};
    copy[day][i].startDate = date;

    if (copy[day][i].startDate >= copy[day][i].endDate) {
      copy[day][i].endDate = moment(date).add(1, 'day');
    }
    setDaysOfWeekObject(copy);
    setInputObject({sid: copy[day][i].sid, day: day});
    validateTimeInputs(day);
  }

  const handleEndDate = (day, j, date, row) => {
    let copy = {...daysOfWeekObject};
    copy[day][j].endDate = date;
    setDaysOfWeekObject(copy);
    handleInput(row.sid, day);
    validateTimeInputs(day);
  };

  const handleTimeOnChange = (e, day, j, row, isStartTime) => {
    const startOrEnd = isStartTime ?
        'startTime' :
        'endTime';
    let copy = daysOfWeekObject;
    copy[day][j][startOrEnd] = e.target.value;
    setDaysOfWeekObject(copy);
    setInputObject({sid: row.sid, day: day});
    validateTimeInputs(day);
  };

  const handleCancel = () => {
    if(props.calendar) {
      props.parent.setState({
        editAvailability: false,
        editAvailabilityDate: null,
        editAvailabilityDayOfWeek: null,
        editAvailabilitiesDefault: []
      });
      try {
        props.parent.getAvailability();
      } catch (err) {
        // no-op
      }
    } else {
      props.setStep(1);
    }
  }

  const cleanData = (array, create = false) => {
    array.forEach((row) => {
      row.startDate = moment(row.startDate).format('YYYY-MM-DD');
      row.startDate = moment(row.startDate).format('YYYY-MM-DD');
      row.startTime = moment(row.startTime, "HH:mm:ss").format('HH:mm');
      row.endTime = moment(row.endTime, "HH:mm:ss").format('HH:mm');
      if(create === true) delete row.sid;
    })
    return array;
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const { ScheduleStore, SessionStore } = props.store;
    const { schedule } = ScheduleStore.locationCalendar;

    // Set the data
    const data = {
      create: createArray,
      update: updateArray,
      delete: deleteArray
    }
    // Remove temporary sids from the create array
    data.create = cleanData(data.create, true)
    data.update = cleanData(data.update)
    data.delete = cleanData(data.delete)

    // check if we need to remove the availability to remove availabilities
    if (data.create.length > 0) {
      try {
        const availabilities = ScheduleStore.availabilities[data.create[0].startDate];
        const noAvailability = availabilities.filter(obj => {
          return obj.excludeDate;
        });
        if (noAvailability.length > 0) {
          data.delete = cleanData(noAvailability);
        }
      } catch (err) {
        // no op
      }
    }

    // If there are no updates, and we have removed the availabilities for a day
    if (data.create.length === 0 && data.update.length === 0 && removeOverrideObject) {
      const removeAvailabilityObj = {
        dayOfWeek: removeOverrideObject.dayOfWeek,
        startDate: removeOverrideObject.startDate,
        endDate: removeOverrideObject.endDate,
        startTime: '00:00',
        endTime: '00:00',
        numberOfSeats: null
      };

      data.create = [removeAvailabilityObj];
    }

    const callback = () => {
      if(!props.calendar) {
        SessionStore.showToaster(translation.updated, 'success');
        setDaysOfWeekObject({
            0: [],
            1: [],
            2: [],
            3: [],
            4: [],
            5: [],
            6: []
        })
          setCreateArray([]);
          setUpdateArray([]);
          setDeleteArray([]);
          getDefaultDates();
      } else {
        props.callback();
        props.closeView();
      }
    }
    ScheduleStore.updateAvailability(schedule.sid, data, callback);
  }

  return(
      <form
          className="availability"
          onSubmit={(e) => handleSubmit(e)}
          noValidate
      >
      <fieldset>
        <ol className="fields availability__list">
          {(customize || !props.calendar) && props.dayOfWeek.map((day, i) => {
            if(daysOfWeekObject[day] && daysOfWeekObject[day].length === 0) {
              return (
                <li key={i} className="enabled">
                  <div className="form-inline">
                    <label className="availability__label --large" htmlFor="sunday-start">
                      {Object.keys(daysOfWeekObject).length > 1 &&
                        translation.days[day]
                      }
                      <span className="meta">{translation.start}</span>
                    </label>
                    <div className="availability__copy">
                      {translation.closed}

                      <button
                        className="btn--link"
                        type="button"
                        onClick={() => addRow(day, i)}
                      >
                        {translation.add_hours}
                      </button>
                    </div>
                  </div>
                </li>
              )
            } else if(daysOfWeekObject[day].length !== 0) {
              const dayRows = [];
              return (

                <li key={i}>

                  <div className='header-div'>
                    <label className="availability__label --large" htmlFor={`${day}-start`}>
                      {translation.days[day]}
                      <span className="meta">{translation.start}</span>
                      {
                        !props.calendar &&

                        <button
                          className="availability__copy-btn"
                          type="button"
                          onClick={() => copyHours(daysOfWeekObject[day], day)}
                          title={translation.copy}
                        >
                          <icons.iconCopy />
                        </button>
                      }
                    </label>
                  </div>


                  {daysOfWeekObject[day].map((row, j) => {
                    if(
                        dayRows.indexOf(`${row.startTime}-${row.endTime}`) === -1 || row.sid.includes('temp')
                    ) {
                      // Make sure we aren’t showing duplicate
                      // start and end times, which can happen
                      // if we are editing a span of multiple weeks.
                      // If we just created the availability always show it
                      // by checking if temp is in the sid
                      dayRows.push(`${row.startTime}-${row.endTime}`);

                      return(
                        <div key={`${row.sid}-availability-item__sp`}>
                          <div className={`availability__item ${props.calendar ? 'calendar__view' : ''}` }>
                            <div className='availability__item_wrap'>
                              <div>
                                <p id={`${row.sid}-validation`} className='availability__validation'></p>
                              </div>
                              <div key={`${row.sid}-form__inline-sp`} className="form-inline">
                                {j !== 0 &&
                                <label className="meta" htmlFor={`${day}-start`}>
                                  {translation.days[day]}
                                  <span className="meta">{translation.start}</span>
                                </label>
                                }
                                <label className='lbl-inline longer-label'>{translation.hours} </label>
                                <div className="availability-content">
                                  <input
                                      type="time"
                                      id={`${row.sid}-start`}
                                      defaultValue={row.startTime || null}
                                      onChange={(e) => handleTimeOnChange(e, day, j, row, true)}
                                      placeholder="hh:mm"
                                      required={true}
                                  />
                                  <span>{translation.to}</span>
                                  <input
                                      type="time"
                                      id={`${row.sid}-end`}
                                      defaultValue={row.endTime || null}
                                      onChange={(e) => handleTimeOnChange(e, day, j, row, false)}
                                      placeholder="hh:mm"
                                      required={true}
                                  />
                                </div>
                              </div>
                              {!props.calendar &&
                              <div>
                                <div className='form-inline'>
                                  <label className='lbl-inline longer-label'>{translation.effective_period}</label>
                                  <div className="availability-content">
                                    <DatePicker
                                        className="calendar-by-day"
                                        selected={new Date (moment(row.startDate))}
                                        onChange={(date) => handleStartDate(date, day, j)}
                                        placeholderText="Select a date"
                                        required
                                    />
                                    <span>{translation.to}</span>
                                    <DatePicker
                                        className="calendar-by-day"
                                        minDate={new Date (row.startDate ? moment(row.startDate).add(1, 'day') : moment().add(1, 'day'))}
                                        selected={new Date(row.endDate ? moment(row.endDate) : moment(row.startDate).add(1, 'day'))}
                                        onChange={(date) => handleEndDate(day, j, date, row)}
                                        placeholderText="Select a date"
                                        required
                                    />
                                  </div>

                                </div>
                              </div>
                              }
                              <div className='form-inline default--radio'>
                                <label className="lbl-inline longer-label">Seats: </label>
                                <div className="availability-content">

                                  <RadioGroup
                                      className='default--radio'
                                      name={`default_seats${j}${day}`}
                                      onChange={(value) => {
                                        let copy = {...daysOfWeekObject}
                                        if(value === "true") copy[day][j].numberOfSeats = null;
                                        if(value === "false") copy[day][j].numberOfSeats = undefined;
                                        setDaysOfWeekObject(copy);
                                      }}
                                      selectedValue={row.numberOfSeats === null ? "true" : "false" }
                                  >

                                    <Radio
                                        id={`g${j}${day}-seats`}
                                        value="true"/> <span>{translation.default} {props.defaultNumberOfSeats}</span>
                                    <Radio
                                        id={`g${j}${day}-seats`}
                                        value="false"
                                    />
                                    {row.numberOfSeats !== null &&
                                    <input type="number" className="small-input" id={`${row.sid}-seats`} onChange={(e) => {
                                      let value = e.target.value
                                      if(isNaN(parseInt(value, 10)) === false) value = parseInt(value, 10)
                                      let copy = daysOfWeekObject
                                      copy[day][j].numberOfSeats = value
                                      setDaysOfWeekObject(copy);
                                      setInputObject({sid: row.sid, day: day})
                                    }}
                                           required
                                        // numberOfSeats value in the text input is an empty string if default number of seats is selected or if is null
                                           value={row.numberOfSeats === null ? "" : row.numberOfSeats}
                                    />
                                    }{row.numberOfSeats === null &&
                                  <span>{translation.custom}</span>
                                  }
                                  </RadioGroup>
                                </div>
                              </div>
                            </div>
                            <div className='delete__icn_wrap'>
                              <button className='delete__icn'
                                      type="button"
                                      onClick={() => deleteRow(day, j, row.sid, row.override, row, props.calendar)}
                              >
                                <icons.iconTimes />

                              </button>
                            </div>
                          </div>
                        </div>
                      )
                    }
                    return null;
                  })}

                  <div className='footer--button'>

                    <button
                      type='button'
                      className="btn--outline "
                      onClick={() => addRow(day, i)}
                    >
                        <span> Add Hours </span>
                        <icons.iconPlus />

                    </button>
                  </div>
                </li>
              )
            }
            return null;
          })}
        </ol>
        {!customize && props.cleanedAvailabilities &&
          props.cleanedAvailabilities.map((availability, i) => {
            return(
              <h3 key={`${availability.sid}-h3-cleaned`}>
                {moment(availability.startTime, 'HH:mm:ss').format('h:mma')} – {moment(availability.endTime, 'HH:mm:ss').format('h:mma')}
              </h3>
            )
          })
        }

        <div className="panel__btns">
          {(customize || !props.calendar) && !isValidated &&
          <div>
            <p className='availability__validation'>{translation.not_validated}</p>
          </div>
          }
          {(customize || !props.calendar) &&
            <button
                className="btn btn--inline"
                type="submit"
                disabled={!isValidated}
            >
              {translation.button}
            </button>
          }
          {!customize && props.calendar &&
            <button className="btn" type="button" onClick={() => customizeAvailability()}>
              {translation.customize}
            </button>
          }
          {customize &&
            <button className="btn--line btn--negative" type="button" onClick={() => removeAvailability()}>
              {translation.remove}
            </button>
          }

          <button
            className="end btn--link"
            onClick={() => handleCancel()}
            type="button"
          >
            {translation.cancel}
          </button>
        </div>
      </fieldset>
    </form>
  )
}

export default  translate('Availability')(observer(Availability));



// WEBPACK FOOTER //
// ./src/app/components/Schedule/Availability.js